import { render, staticRenderFns } from "./DataUsage.vue?vue&type=template&id=1784529a&scoped=true"
import script from "./DataUsage.vue?vue&type=script&lang=js"
export * from "./DataUsage.vue?vue&type=script&lang=js"
import style0 from "./DataUsage.vue?vue&type=style&index=0&id=1784529a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1784529a",
  null
  
)

export default component.exports